import React from 'react';

class Blog extends React.Component{
    render(){
        return(
            <h1>Blog</h1>
        )
    }
}

export default Blog;


// WEBPACK FOOTER //
// ./src/containers/Blog.js